import { useRouter, type RouteLocationRaw } from 'vue-router';

export function useNavigateBack() {
  const router = useRouter();

  const hasInAppBackTarget = () => {
    const historyState = router.options.history.state as { back?: string | null } | null;
    return Boolean(historyState?.back);
  };

  const navigateBack = (fallback: RouteLocationRaw) => {
    if (hasInAppBackTarget()) {
      router.back();
      return;
    }
    router.push(fallback);
  };

  return { navigateBack };
}
